import React, { Fragment, useEffect } from 'react';
import { Form, Row, Col,Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import ButtonInput from '../../Helpers/Inputs/ButtonInput';
import { CheckboxInput } from '../../Helpers/Inputs';
import { Button } from '@material-ui/core';
import ThermometerIcon from '../../../icons/thermometer.svg';
import BottleIcon from '../../../icons/bottle.svg';
import HistorytIcon from '../../../icons/history.svg';
import HealthNotesIcon from '../../../icons/health-notes.svg';
import QuoteBasicInfo from './QuoteBasicInfo';

export default function MyHealthProfile(props) {

  const { register, handleSubmit, setValue } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });
  const checknoneOfTheAbove =
    props.formState.personalHistoryMedical || props.formState.hospitalized || props.formState.familyHistory || props.formState.treatedAlcoholSubstanceAbuse;

  useEffect(() => {
    register({ name: 'personalHistoryMedical' });
    setValue('personalHistoryMedical', props.formState.personalHistoryMedical);

    register({ name: 'hospitalized' });
    setValue('hospitalized', props.formState.hospitalized);

    register({ name: 'familyHistory' });
    setValue('familyHistory', props.formState.familyHistory);

    register({ name: 'treatedAlcoholSubstanceAbuse' });
    setValue('treatedAlcoholSubstanceAbuse', props.formState.treatedAlcoholSubstanceAbuse);
  }, [register]);

  useEffect(() => {
    if (checknoneOfTheAbove && props.formState.noneApply) {
      props.onFieldChange('noneApply', false);
    } else if (!checknoneOfTheAbove && !props.formState.noneApply) {
      props.onFieldChange('noneApply', true);
    }
  }, [checknoneOfTheAbove]);

  const buttonData = [
    {
      icon: HealthNotesIcon,
      title: 'Personal history of chronic medical or health condition',
      value: props.formState.personalHistoryMedical,
      field: 'personalHistoryMedical',
    },
    {
      icon: ThermometerIcon,
      title: 'Hospitalized within the last 2 years',
      value: props.formState.hospitalized,
      field: 'hospitalized',
    },
    {
      icon: HistorytIcon,
      title: 'Family history of cancer or cardiovascular disease before age 70',
      value: props.formState.familyHistory,
      field: 'familyHistory',
    },
    {
      icon: BottleIcon,
      title: 'Treated for alcohol or drug abuse',
      value: props.formState.treatedAlcoholSubstanceAbuse,
      field: 'treatedAlcoholSubstanceAbuse',
    },
  ];

  const handleValueChange = (field, value) => {
    props.onFieldChange(field, value);
  };

  const clearValues = () => {
    props.resetHealthProfileValues();
  };
  return (
    <Fragment>
      <Container className="health-container personalize-step">
        <Row className="justify-content-center health-title">
          <h4 className="text-center">Select all that apply to you</h4>
        </Row>
        <Row className="justify-content-center">
          <p className="health-line">This will help us to find quotes and policy options to meet your unique needs.
</p>
        </Row>
        <Form onSubmit={handleSubmit(props.onNext)}>
          <Row className={`justify-content-center ${props.isCustomizeTerm ? '' : 'mx-auto'} pt-3`} role="group" aria-labelledby="Select Personalizing Options">
            {buttonData.map((d, index) => (
              <Col sm='auto' className="d-flex justify-content-center healthQuestion-div" key={index}>
                <ButtonInput icon={d.icon} title={d.title} subtitle={d.subtitle} value={d.value} noMargin onClick={() => handleValueChange(d.field, !d.value)} />
              </Col>
            ))}
          </Row>

          <Row className="justify-content-center">
            <CheckboxInput id="none-apply" onChange={clearValues} checked={props.formState.noneApply} name="none-apply" inputRef={register} label="None of these apply" />
          </Row>
          <Row className="pre-quote-nav-control">
            <Col className="text-left btn-back">
              <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack}>
                {props.isCustomizeTerm ? 'CANCEL' : 'BACK'}
              </Button>
            </Col>
            <Col className="text-right">
              <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">
                NEXT
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
      {!props.isCustomizeTerm && <QuoteBasicInfo basicInfo={props.basicInfo}></QuoteBasicInfo>}
    </Fragment>
  );
}

MyHealthProfile.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};


MyHealthProfile.DefaultFormState = () => {
  return {
    personalHistoryMedical: false,
    hospitalized: false,
    familyHistory: false,
    treatedAlcoholSubstanceAbuse: false,
    noneApply: true,
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/MyHealthProfile.js